import styled from "@emotion/styled";
import themes from "@styles/themes";

export const MainLayoutContainer = styled.div`
    width: 80%;
    padding: 0;
    margin: 0 auto;
    background-color: ${themes.colors.bgColor};
    padding-top: 7rem;
`;
